import * as React from "react";

export const TemplateContext = React.createContext<any>(undefined);
